module.exports = __webpack_public_path__ + "static/media/vivi-mostrandoabaixo-esquerda.350b5a8d.svg";